// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__16sJb","bigColWidth":"Table_bigColWidth__WVKOv","biggerColWidth":"Table_biggerColWidth___Kws0","row":"Table_row__2OqCV","col":"Table_col__3wEQW"};